import { render } from "./heroImage.svg?vue&type=template&id=2b3fc2ac"
const script = {}
script.render = render

export default script